export default {
  buttons: {
    save: 'Speichern',
    confirm: 'Bestätigen',
    cancel: 'Abbrechen',
  },
  confirmation: {
    title: 'Sind Sie sicher, dass Sie mit externen Diensten synchronisieren möchten?',
  },
};
